const DepartmentPositionSection = ({ jobTitles, setJobTitles }) => {
  const handleAddPosition = () => {
    setJobTitles([
      ...jobTitles,
      {
        id: Date.now(),
        title: "",
        employeeCount: 0,
      },
    ]);
  };

  return (
    <div className="mt-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0 fs-4 fw-medium">Positions</h5>

        <button
          type="button"
          className="btn btn-light border"
          onClick={handleAddPosition}
          style={{
            border: "1px solid #319EA9",
            color: "#319EA9",
            backgroundColor: "transparent",
            padding: "8px 16px",
            borderRadius: "8px",
            fontWeight: 500,
          }}
        >
          + Add Position
        </button>
      </div>

      {jobTitles.map((job, index) => (
        <div key={job.id} className="border rounded p-3 mb-3 ">
          <div className="row justify-content-between">
            <div className="col-md-10">
              <label className="form-label">Job Title</label>

              <input
                className="form-control full-width"
                value={job.title}
                onChange={(e) => {
                  const next = [...jobTitles];
                  next[index].title = e.target.value;
                  setJobTitles(next);
                }}
              />
            </div>

            <div className="col-md-2 d-flex align-items-end">
              <button
                type="button"
                className="btn btn-danger w-100"
                onClick={() =>
                  setJobTitles(jobTitles.filter((_, i) => i !== index))
                }
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DepartmentPositionSection;
